imp
<template>
  <BaseInput
    id="fileUploadMulti"
    type="file"
    @change="handleFileChange"
    v-show="false"
    accept="image/*"
    multiple
    v-bind="$attrs"
  />
  <div>
    <base-button
      border-radius="8"
      :paddingVertical="5"
      :paddingHorizonal="5"
      :marginVertical="0"
      backgroundColor="#FFFFFF"
      @click="chooseFiles('fileUploadMulti')"
      style="
        border-style: dashed;
        border-width: 1.5px;
        width: 6rem;
        height: 6rem;
        background-repeat: repeat-y;
      "
    >
      <div class="upload-btn-container">
        <IconPlus />
      </div>
    </base-button>
  </div>
</template>

<script>
import BaseInput from "@/modules/auth/components/base/Input.vue";
import BaseButton from "@/modules/auth/components/base/Button.vue";
import IconPlus from "@/modules/auth/components/icon/Plus.vue";
import HandleUpload from "../mixins/handle";
export default {
  inheritAttrs: false,
  mixins: [HandleUpload],
  components: {
    BaseInput,
    BaseButton,
    IconPlus,
  },
};
</script>
<style scoped>
.upload-btn-container {
  width: 100%;
  height: 100%;
  display: flex;
  border-radius: 0.5rem;
  align-items: center;
  justify-content: center;
  background-color: grey;
}
</style>
